var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLaunch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 6.5L16 1.5M16 1.5H11M16 1.5L9.33333 8.16667M6.83333 3.16667H5C3.59987 3.16667 2.8998 3.16667 2.36502 3.43915C1.89462 3.67883 1.51217 4.06129 1.27248 4.53169C1 5.06647 1 5.76654 1 7.16667V12.5C1 13.9001 1 14.6002 1.27248 15.135C1.51217 15.6054 1.89462 15.9878 2.36502 16.2275C2.8998 16.5 3.59987 16.5 5 16.5H10.3333C11.7335 16.5 12.4335 16.5 12.9683 16.2275C13.4387 15.9878 13.8212 15.6054 14.0608 15.135C14.3333 14.6002 14.3333 13.9001 14.3333 12.5V10.6667",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaunch);
export default __webpack_public_path__ + "static/media/launch.16d7760d9617362cd4dd6ce03b3f1fcc.svg";
export { ForwardRef as ReactComponent };